'use strict';

exports.__esModule = true;
exports.Dependencies = exports.KINDS = exports.STATIC_WEAK = exports.STATIC = exports.REACTIVE_WEAK = exports.REACTIVE = undefined;

var _ron = require('@swarm/ron');

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REACTIVE = exports.REACTIVE = 0;
var REACTIVE_WEAK = exports.REACTIVE_WEAK = 1;
var STATIC = exports.STATIC = 2;
var STATIC_WEAK = exports.STATIC_WEAK = 3;
var KINDS = exports.KINDS = [REACTIVE, REACTIVE_WEAK, STATIC, STATIC_WEAK];

var Dependencies = exports.Dependencies = function () {
  function Dependencies() {
    _classCallCheck(this, Dependencies);

    this.deps = [{}, {}, {}, {}];
    this.index = {};
  }

  Dependencies.prototype.diff = function diff(from) {
    var diff = new Dependencies();
    for (var _iterator = Object.keys(this.index), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var key = _ref;

      if (!from.index.hasOwnProperty(key) || from.index[key] !== this.index[key]) {
        diff.put(this.index[key], key);
      }
    }
    return diff;
  };

  Dependencies.prototype.toString = function toString(kind) {
    var ret = Object.keys(typeof kind !== 'undefined' ? this.deps[kind] : this.index);
    if (!ret.length) return '';

    var res = '';
    ret.map(function (i) {
      return _ronUuid2.default.fromString(i);
    }).reduce(function (prev, current) {
      res += '#';
      res += current.toString(prev);
      return current;
    }, _ronUuid.ZERO);
    return res;
  };

  Dependencies.prototype.options = function options(kind) {
    switch (kind) {
      case REACTIVE:
        return { ensure: true };
      case REACTIVE_WEAK:
        return;
      case STATIC:
        return { once: true, ensure: true };
      case STATIC_WEAK:
        return { once: true };
    }
  };

  Dependencies.prototype.put = function put(k, id) {
    this.index[id] = k;
    delete this.deps[REACTIVE][id];
    delete this.deps[REACTIVE_WEAK][id];
    delete this.deps[STATIC][id];
    delete this.deps[STATIC_WEAK][id];
    this.deps[k][id] = true;
  };

  Dependencies.getKind = function getKind(type, directives) {
    directives = directives || {};
    if (type === 'query' && directives.hasOwnProperty('live') || type === 'subscription' && !directives.hasOwnProperty('static')) {
      return directives.hasOwnProperty('weak') ? REACTIVE_WEAK : REACTIVE;
    } else {
      return directives.hasOwnProperty('weak') ? STATIC_WEAK : STATIC;
    }
  };

  return Dependencies;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/db/lib/deps.js
// module id = 89
// module chunks = 0